"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cowApprovalNeeded = void 0;
const caip_1 = require("@shapeshiftoss/caip");
const api_1 = require("../../../api");
const erc20Allowance_abi_1 = require("../../utils/abi/erc20Allowance-abi");
const bignumber_1 = require("../../utils/bignumber");
const helpers_1 = require("../../utils/helpers/helpers");
const constants_1 = require("../utils/constants");
async function cowApprovalNeeded({ adapter, web3 }, { quote, wallet }) {
    const { sellAsset } = quote;
    const { assetReference: sellAssetErc20Address, assetNamespace } = (0, caip_1.fromAssetId)(sellAsset.assetId);
    try {
        if (assetNamespace !== 'erc20') {
            throw new api_1.SwapError('[cowApprovalNeeded] - unsupported asset namespace', {
                code: api_1.SwapErrorTypes.UNSUPPORTED_NAMESPACE,
                details: { assetNamespace },
            });
        }
        const receiveAddress = await adapter.getAddress({ wallet, bip44Params: quote.bip44Params });
        const allowanceResult = await (0, helpers_1.getERC20Allowance)({
            web3,
            erc20AllowanceAbi: erc20Allowance_abi_1.erc20AllowanceAbi,
            sellAssetErc20Address,
            spenderAddress: constants_1.COW_SWAP_VAULT_RELAYER_ADDRESS,
            ownerAddress: receiveAddress,
        });
        const allowanceOnChain = (0, bignumber_1.bnOrZero)(allowanceResult);
        return {
            approvalNeeded: allowanceOnChain.lt((0, bignumber_1.bnOrZero)(quote.sellAmountBeforeFeesCryptoBaseUnit)),
        };
    }
    catch (e) {
        if (e instanceof api_1.SwapError)
            throw e;
        throw new api_1.SwapError('[cowApprovalNeeded]', {
            cause: e,
            code: api_1.SwapErrorTypes.CHECK_APPROVAL_FAILED,
        });
    }
}
exports.cowApprovalNeeded = cowApprovalNeeded;
